export enum ModificationTypeEnum {
  UnappliedPayment,
  CreditCardRefund,
}
